import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';

const initialState = {
    AuthorDashboard: {},
};

const AuthorDashBoardSlice = createSlice({
    name: 'authordashboard',
    initialState,
    reducers: {
        setAuthorDashBoard(state, action) {
            state.AuthorDashboard = action.payload;
        }


    },
});




export const AuthorDashBoardAPi = (tokendata) => async (dispatch) => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/author/dashboard`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "jfdd")
            dispatch(setAuthorDashBoard(res?.data))
        })
        .catch((err) => {
            console.log(err?.response, "errerrr");

        })
}

export const { setAuthorDashBoard } = AuthorDashBoardSlice.actions;
const AuthorDashboardReducer = AuthorDashBoardSlice.reducer;

export default AuthorDashboardReducer;
